import { render, staticRenderFns } from "./WPasswordTextField.vue?vue&type=template&id=ef5ec0ac&scoped=true&"
import script from "./WPasswordTextField.vue?vue&type=script&lang=js&"
export * from "./WPasswordTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ec0ac",
  null
  
)

export default component.exports